interface NavBadgeProps {
  visible: boolean
}

export default function NavBadge({ visible }: NavBadgeProps) {
  if (!visible) return null

  return (
    <span
      className="nav-badge-dot"
      style={{
        width: 7,
        height: 7,
        borderRadius: '50%',
        backgroundColor: 'var(--color-accent)',
        flexShrink: 0,
      }}
      aria-label="Needs attention"
    />
  )
}
